export const noop = () => void 0

export const noopArr = [] as any[]
